import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useGroupItem
 */
import { useSingleton } from '@tencent/glue-react-use';
import { useEffect, useState } from 'react';
import { GroupItem } from '@tencent/glue-model-group';
import { useGroupInstance } from '../context/group';
export function useGroupItem(props) {
  var groupInfo = useGroupInstance();
  var itemInfo = useSingleton(function () {
    return new GroupItem(groupInfo, props);
  });

  var _useState = useState(function () {
    return itemInfo.getGroupItemInfo(props);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      conf = _useState2[0],
      setConf = _useState2[1];

  useEffect(function () {
    var callback = function callback() {
      setConf(itemInfo.getGroupItemInfo(props));
    };

    itemInfo.addListener('group-change', callback);
    return function () {
      itemInfo.removeListener('group-change', callback);
      itemInfo.dispose();
    };
  }, [itemInfo]);
  return conf;
}